export default __webpack_public_path__ + "static/media/waving-hand-2x.092a8da2.png";